/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useState } from "react";
import appStyles from "../../../App.module.css";
import { formatAmount, formatDate } from "../../../app-constants";
import { BusinessTravelContext } from "../../BusinessTravel";
import {
  additionalDestinations,
  btCurrencyProductIds,
  businessTravelDocs,
  businessTravelEUDocs,
  businessTravelUKDocs,
  currencyDropDownUKRegion,
  localLanguageDocsByCountryCode,
  localLanguagesByCountryCode,
  PreviewPolicyEU,
  PreviewPolicyUK,
} from "../../config/bt-constants";
import { IBusinessTravelContext } from "../../config/interfaces";
import Popup from "../Popup";
import ArrowOutward from "../icons/ArrowOutward";
import BenefitSummaryTableModal from "../modal/BenefitSummaryTableModal";
import EditCurrencyAndCompany from "./EditCurrencyAndCompany";
type QuoteSummaryProps = {
  showPolicyTerm?: boolean;
  Premium?: boolean;
};
const QuoteSummary = (props: QuoteSummaryProps) => {
  const { showPolicyTerm = false, Premium = false } = props;
  const [showCurrencyEditor, setShowCurrencyEditor] = useState<boolean>(false);
  const [showBenefitSummaryModal, setShowBenefitSummaryModal] = useState<boolean>(false);

  const { quoteData, currentStep, quoteResult, version, order } = useContext(
    BusinessTravelContext
  ) as IBusinessTravelContext;

  const _selectedDestination = quoteData?.host_country?.code;
  const _productId = quoteData.productId == btCurrencyProductIds.BTEUProductId;
  const _isEUVersion = version === "EU";
  const _isUKVersion = version === "UK";
  const _isLocalLanguage = additionalDestinations.includes(_selectedDestination) && _productId && _isEUVersion;
  const _showLocalLanguage = localLanguagesByCountryCode[_selectedDestination];
  const _localLanguageLinks = localLanguageDocsByCountryCode[_selectedDestination];

  return (
    <>
      <div className={` ${appStyles.btQuoteResultWrapper}`}>
        <div className={`${appStyles.quoteTotalBoxOuter} ${appStyles.btQuoteTotalBoxOuter}`}>
          <div className={`${appStyles.btBorderBox} ${appStyles.btQuoteTotalBox}`}>
            <div className={` ${appStyles.quoteSummaryWrapper}`}>
              <h3 className={appStyles.btTitle}>Business Travel Plan</h3>
              {showPolicyTerm && (
                <>
                  <div className={`${appStyles.tripSummaryValue} ${appStyles.btQuoteTripPlanDetail}`}>
                    <h5 className={appStyles.btPlanLabel}>Policy Term</h5>
                    <span className={`${appStyles.btPlanAmount} ${appStyles.btMargin0}`}>
                      {formatDate(new Date(quoteData?.start_date))} - {formatDate(new Date(quoteData?.end_date))}
                    </span>
                  </div>
                  <div className={`${appStyles.tripSummaryValue} ${appStyles.btQuoteTripPlanDetail}`}>
                    <h5 className={appStyles.btPlanLabel}>Number of Trips</h5>
                    <span className={`${appStyles.btPlanAmount} ${appStyles.btMargin0}`}>
                      {quoteData?.noOfTrips?.from}-{quoteData?.noOfTrips?.till}
                    </span>
                  </div>

                  <hr className={appStyles.btHrStyle} />
                </>
              )}
              <div>
                <div className={`${appStyles.btQuoteTripPlanDetail}`}>
                  <h5 className={appStyles.btPlanLabel}>Premium</h5>
                  <span className={`${appStyles.btPlanAmount} ${appStyles.btMargin0}`}>
                    {formatAmount(
                      Premium
                        ? order?.premium
                        : Number(quoteResult?.quoted_price) - Number(quoteResult?.taxes?.tax) || 0,
                      "US",
                      quoteData?.currency
                    )}
                  </span>
                </div>
                <div className={`${appStyles.btQuoteTripPlanDetail}`}>
                  <h5 className={appStyles.btPlanLabel}>Taxes</h5>
                  <span className={`${appStyles.btPlanAmount} ${appStyles.btMargin0}`}>
                    {formatAmount(quoteResult?.taxes?.tax || 0, "US", quoteData?.currency)}
                  </span>
                </div>
                <div className={`${appStyles.btQuoteTripPlanDetail}`}>
                  <h5 className={appStyles.btPlanLabel}>
                    Total
                    {currentStep !== 3 ? (
                      <>
                        &nbsp; (
                        <span
                          className={`${currentStep !== 2 ? appStyles.btPlanLabelCurrency : ""} ${
                            version === "EU" ? appStyles.onlyInlineElement : null
                          }`}
                          onClick={() => {
                            if (version === "EU") {
                              return;
                            }
                            currentStep !== 2 && setShowCurrencyEditor(true);
                          }}
                        >
                          {quoteData?.currency}
                        </span>
                        )
                      </>
                    ) : null}
                  </h5>
                  <span className={`${appStyles.btPlanAmount} ${appStyles.btMargin0}`}>
                    {formatAmount(quoteResult?.quoted_price || 0, "US", quoteData?.currency)}
                  </span>
                </div>
                {showCurrencyEditor && (
                  <Popup
                    onClose={() => {
                      setShowCurrencyEditor(false);
                    }}
                    title="Preferred currency"
                    showTitle={false}
                    children={
                      <EditCurrencyAndCompany
                        itemsArray={currencyDropDownUKRegion}
                        closeModel={setShowCurrencyEditor}
                        type="currency"
                      />
                    }
                  />
                )}
              </div>
              {!showPolicyTerm && (
                <>
                  <hr className={appStyles.btHrStyle} />
                  <div className={appStyles.quoteTotalSummaryWrapper}>
                    <h1 className={appStyles.colorPrimary}>
                      {formatAmount(quoteResult?.quoted_price || 0, "US", quoteData?.currency)}
                    </h1>
                    <small className={appStyles.priceText}>Total including taxes</small>
                  </div>
                </>
              )}
              <hr className={appStyles.btHrStyle} />

              {!showPolicyTerm ? (
                <div className={`${appStyles.paymentButtonWrapper} ${appStyles.btSummaryLinkWrap}`}>
                  <a
                    className={`${appStyles.bfSummaryLinkButton}`}
                    rel="noopener noreferrer"
                    onClick={() => setShowBenefitSummaryModal(true)}
                  >
                    See benefits summary
                  </a>

                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      _isUKVersion
                        ? PreviewPolicyUK[`${quoteData?.currency}`]
                        : PreviewPolicyEU[`${quoteData?.currency}`]
                    }
                    className={`${appStyles.bfSummaryLinkButton}`}
                  >
                    Preview policy&nbsp;
                    {_isLocalLanguage ? "in English" : null}
                    <ArrowOutward />
                  </a>

                  {_isLocalLanguage ? (
                    <a
                      href={_localLanguageLinks.previewPolicy}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${appStyles.bfSummaryLinkButton}`}
                    >
                      Preview policy in {_showLocalLanguage}
                      <ArrowOutward />
                    </a>
                  ) : null}

                  <a
                    href={_isUKVersion ? businessTravelUKDocs?.IPID : businessTravelEUDocs?.IPID}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${appStyles.bfSummaryLinkButton}`}
                  >
                    View IPID {_isLocalLanguage ? "in English" : null}
                    <ArrowOutward />
                  </a>

                  {_isLocalLanguage ? (
                    <a
                      href={_localLanguageLinks.ipid}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${appStyles.bfSummaryLinkButton}`}
                    >
                      View IPID in {_showLocalLanguage}
                      <ArrowOutward />
                    </a>
                  ) : null}

                  <a
                    href={_isUKVersion ? businessTravelUKDocs?.customerCharter : businessTravelEUDocs?.customerCharter}
                    rel="noopener noreferrer"
                    target="_blank"
                    className={`${appStyles.bfSummaryLinkButton}`}
                  >
                    Information about our services <ArrowOutward />
                  </a>

                  {_isLocalLanguage ? (
                    <a
                      href={_localLanguageLinks.serviceInfo}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${appStyles.bfSummaryLinkButton}`}
                    >
                      Information about our services in {_showLocalLanguage} <ArrowOutward />
                    </a>
                  ) : null}
                </div>
              ) : (
                <div className={`${appStyles.paymentButtonWrapper} ${appStyles.btSummaryLinkWrap}`}>
                  <a
                    href={
                      _isUKVersion
                        ? PreviewPolicyUK[`${quoteData?.currency}`]
                        : PreviewPolicyEU[`${quoteData?.currency}`]
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${appStyles.bfSummaryLinkButton}`}
                  >
                    Download policy
                  </a>
                  <a
                    href={_isUKVersion ? businessTravelUKDocs?.IPID : businessTravelEUDocs?.IPID}
                    rel="noopener noreferrer"
                    target="_blank"
                    className={`${appStyles.bfSummaryLinkButton}`}
                  >
                    Download IPID
                  </a>
                </div>
              )}
            </div>
          </div>
          {!showPolicyTerm && (
            <div className={`${appStyles.btBorderBox} ${appStyles.btQuoteAdvisoryBox}`}>
              <div className={appStyles.btQuoteAdvisoryHeadWrap}>
                <span className={appStyles.infoIcon}></span>

                <div>
                  <h5 className={appStyles.btQuoteAdvisoryTitle}>Government Travel Advisory Countries </h5>
                  <p className={appStyles.btQuoteAdvisoryDetail}>{businessTravelDocs.governmentTravelAdvisory}</p>
                </div>
              </div>
            </div>
          )}

          {showBenefitSummaryModal && (
            <Popup
              onClose={() => {
                setShowBenefitSummaryModal(false);
              }}
              title=""
              styleBenefitModal={true}
              children={<BenefitSummaryTableModal version={version} quoteData={quoteData} />}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default QuoteSummary;
